<template>
<v-container class="pb100">

  <v-row justify="center" align="center">
    <v-col cols="12" lg="10" xl="6">
      <overview :projects="published"></overview>
    </v-col>
  </v-row>

  <v-row justify="center" align="center">
    <v-col cols="12" lg="10" xl="6">
      <current-rank></current-rank>
    </v-col>
  </v-row>


  <v-row justify="center" v-if="projects.length">
    <v-col cols="6" md="6" lg="4" xl="3">
      <v-select outlined hide-details :label="`Showing (${projects.length})`" v-model="filter" :items="['Published','Rejected']"></v-select>
    </v-col>
    <v-col cols="6" md="6" lg="4" xl="3">
      <v-select outlined hide-details label="Sort by" :items="['Newest','Oldest','Title']" v-model="sort"></v-select>
    </v-col>
  </v-row>

  <v-row justify="center">
    <v-col cols="12" lg="10" xl="6">
      <v-container fluid class="pa-0">
        <v-row>
          <v-col cols="12" lg="12" v-for="(project,i) in projectsList" :key="i">
            <project :project="project"></project>
          </v-col>
        </v-row>
      </v-container>

    </v-col>
  </v-row>

</v-container>
</template>
<script>
import overview from "./overview"
import currentRank from "./current_rank"
import project from "./project"

export default {
  name: "",
  components: {
    overview,
    currentRank,
    project
  },
  data: () => ({
    filter: 'Published',
    sort: "Newest",
    projects: [],
    loading: false
  }),
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      this.projects = await this.$api(`/account/user/projects/completed`)
      this.loading = false
    }
  },
  computed: {
    published(){
      return this.projects.filter(p=>{
        return p.status===11
      })
    },
    projectsList() {

      let sort_by = 'id';
      let sort_ascending = false;

      if (this.sort === "Oldest") {
        sort_ascending = true;
        sort_by = 'id'
      }
      if (this.sort === "Newest") {
        sort_ascending = false;
        sort_by = 'id'
      }
      if (this.sort === "Title") {
        sort_ascending = true;
        sort_by = 'title'
      }


      return this.projects.filter(function(project) {
        if (this.filter) {
          if (this.filter === "Published" && project.status === 11) {
            return true
          }
          if (this.filter === "Rejected" && project.status === 13) {
            return true
          }
          return false
        } else {
          return true
        }
      }.bind(this)).sort(function(a, b) {


        if (a[sort_by] < b[sort_by]) {
          return sort_ascending ? -1 : 1
        }
        if (a[sort_by] > b[sort_by]) {
          return sort_ascending ? 1 : -1
        }
        return 0

      }.bind(this))
    }
  }
}
</script>
<style lang="scss" >
.progress-outter {
    width: 100%;
    background-color: #777777;
    height: 32px;
    border-radius: 50px;
    position: relative;
}
.progress-content {
    position: absolute;
    top: 0;
    left: 0;
    height: 32px;
    border-radius: 50px;
    width: 0;
    -webkit-transition: all 1s ease-out 0s;
    -moz-transition: all 1s ease-out 0s;
    -ms-transition: all 1s ease-out 0s;
    -o-transition: all 1s ease-out 0s;
    transition: all 1s ease-out 0s;
}
.progress-text {
    color: #fff;
    padding: 0 25px;
    position: absolute;
    top: 0;
    left: 0;
    line-height: 32px;
}

.rank-star .fa-star:before {
    color: transparent;
    position: relative;
    background-clip: text;
    -webkit-background-clip: text;
}

.rank-1-star .fa-star:before {
    background-image: -webkit-linear-gradient(left,#f12711 0%,#f5af19 100%);
    background-image: -o-linear-gradient(left,#f12711 0%,#f5af19 100%);
    background-image: linear-gradient(to left,#f12711 0%,#f5af19 100%);
}
.rank-1-bg {
    background: -webkit-linear-gradient(left,#f12711 0%,#f5af19 100%);
    background: -o-linear-gradient(left,#f12711 0%,#f5af19 100%);
    background: linear-gradient(to left,#f12711 0%,#f5af19 100%);
}

.rank-2-star .fa-star:before {
    background-image: -webkit-linear-gradient(left,#0575E6 0%,#00F260 100%);
    background-image: -o-linear-gradient(left,#0575E6 0%,#00F260 100%);
    background-image: linear-gradient(to left,#0575E6 0%,#00F260 100%);

}
.rank-2-bg {
    background: -webkit-linear-gradient(left,#0575E6 0%,#00F260 100%);
    background: -o-linear-gradient(left,#0575E6 0%,#00F260 100%);
    background: linear-gradient(to left,#0575E6 0%,#00F260 100%);
}

.rank-3-star .fa-star:before {
    background-image: -webkit-linear-gradient(left,#ec2F4B 0%,#009FFF 100%);
    background-image: -o-linear-gradient(left,#ec2F4B 0%,#009FFF 100%);
    background-image: linear-gradient(to left,#ec2F4B 0%,#009FFF 100%);
}
.rank-3-bg {
    background: -webkit-linear-gradient(left,#ec2F4B 0%,#009FFF 100%);
    background: -o-linear-gradient(left,#ec2F4B 0%,#009FFF 100%);
    background: linear-gradient(to left,#ec2F4B 0%,#009FFF 100%);
}

.rank-4-star .fa-star:before {
    background-image: -webkit-linear-gradient(left,#333399 0%,#ff00cc 100%);
    background-image: -o-linear-gradient(left,#333399 0%,#ff00cc 100%);
    background-image: linear-gradient(to left,#333399 0%,#ff00cc 100%);
}
.rank-4-bg {
    background: -webkit-linear-gradient(left,#333399 0%,#ff00cc 100%);
    background: -o-linear-gradient(left,#333399 0%,#ff00cc 100%);
    background: linear-gradient(to left,#333399 0%,#ff00cc 100%);
}

.rank-5-star .fa-star:before {
    background-image: -webkit-linear-gradient(left,#3a7bd5 0%,#00d2ff 100%);
    background-image: -o-linear-gradient(left,#3a7bd5 0%,#00d2ff 100%);
    background-image: linear-gradient(to left,#3a7bd5 0%,#00d2ff 100%);
}
.rank-5-bg {
    background: -webkit-linear-gradient(left,#3a7bd5 0%,#00d2ff 100%);
    background: -o-linear-gradient(left,#3a7bd5 0%,#00d2ff 100%);
    background: linear-gradient(to left,#3a7bd5 0%,#00d2ff 100%);
}

.rank-6-star .fa-star:before {

    background-image: -webkit-linear-gradient(left,#799F0C 0%,#FFE000 100%);
    background-image: -o-linear-gradient(left,#799F0C 0%,#FFE000 100%);
    background-image: linear-gradient(to left,#799F0C 0%,#FFE000 100%);

}
.rank-6-bg {
    background: -webkit-linear-gradient(left,#799F0C 0%,#FFE000 100%);
    background: -o-linear-gradient(left,#799F0C 0%,#FFE000 100%);
    background: linear-gradient(to left,#799F0C 0%,#FFE000 100%);
}

.rank-7-star .fa-star:before {
    background-image: -webkit-linear-gradient(left,#1F1C18 0%,#8E0E00 100%);
    background-image: -o-linear-gradient(left,#1F1C18 0%,#8E0E00 100%);
    background-image: linear-gradient(to left,#1F1C18 0%,#8E0E00 100%);
}
.rank-7-bg {
    background: -webkit-linear-gradient(left,#1F1C18 0%,#8E0E00 100%);
    background: -o-linear-gradient(left,#1F1C18 0%,#8E0E00 100%);
    background: linear-gradient(to left,#1F1C18 0%,#8E0E00 100%);
}

.rank-8-star .fa-star:before {
    background-image: -webkit-linear-gradient(left,#753a88 0%,#cc2b5e 100%);
    background-image: -o-linear-gradient(left,#753a88 0%,#cc2b5e 100%);
    background-image: linear-gradient(to left,#753a88 0%,#cc2b5e 100%);
}
.rank-8-bg {
    background: -webkit-linear-gradient(left,#753a88 0%,#cc2b5e 100%);
    background: -o-linear-gradient(left,#753a88 0%,#cc2b5e 100%);
    background: linear-gradient(to left,#753a88 0%,#cc2b5e 100%);
}

.rank-9-star .fa-star:before {
    background-image: -webkit-linear-gradient(left,#000000 0%,#434343 100%);
    background-image: -o-linear-gradient(left,#000000 0%,#434343 100%);
    background-image: linear-gradient(to left,#000000 0%,#434343 100%);
}
.rank-9-bg {
    background: -webkit-linear-gradient(left,#000000 0%,#434343 100%);
    background: -o-linear-gradient(left,#000000 0%,#434343 100%);
    background: linear-gradient(to left,#000000 0%,#434343 100%);
}

.rank-10-star .fa-star:before {
    background-image: -webkit-linear-gradient(left,#F7971E 0%,#FFD200 100%);
    background-image: -o-linear-gradient(left,#F7971E 0%,#FFD200 100%);
    background-image: linear-gradient(to left,#F7971E 0%,#FFD200 100%);
}
.rank-10-bg {
    background: -webkit-linear-gradient(left,#F7971E 0%,#FFD200 100%);
    background: -o-linear-gradient(left,#F7971E 0%,#FFD200 100%);
    background: linear-gradient(to left,#F7971E 0%,#FFD200 100%);
}
</style>
